import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TGetSingleContractorPaymentAsContractorRequestSchema,
  TGetSingleContractorPaymentAsContractorResponseSchema,
} from "./getSingleContractorPaymentAsContractor.schema";

export const getSingleContractorPaymentAsContractor = (
  axios: IAxiosInstance
) => {
  return async (
    params: TGetSingleContractorPaymentAsContractorRequestSchema
  ): Promise<TGetSingleContractorPaymentAsContractorResponseSchema> => {
    const response = await axios.noRetry.get<
      IApiResponse<TGetSingleContractorPaymentAsContractorResponseSchema>
    >(`/api/getContractorPaymentAsContractor/${params.contractorPaymentID}`);
    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
